import {
  CatSegmentedControl,
  CatSegmentedControlItem,
  CatTooltip,
  CatTextPassage
} from 'components/blocks-components';
import MeasureUnitSelectorBody from '../measure-unit-selector-body';
import cx from 'classnames';
import styles from './shortened-measure-unit-selector-body.module.scss';
import { MeasureUnitSelector } from '../types';

const ShortenedMeasureUnitSelectorBody = ({
  activeIndex,
  onChangeUom,
  uomData
}: MeasureUnitSelector) => {
  return (
    <>
      <div className="d-md-block d-none">
        <CatSegmentedControl
          activeIndex={activeIndex}
          data-testid="shortened-measure-unit-selector"
        >
          {uomData.map(({ unit, translation, testId }) => (
            <CatSegmentedControlItem
              onClick={() => onChangeUom(unit)}
              key={unit}
              data-testid={testId}
            >
              <CatTooltip position="top-start" className="d-flex">
                <span
                  slot="trigger"
                  className={cx(
                    'd-block overflow-hidden text-truncate text-nowrap',
                    styles['measure-unit-selector__tooltip']
                  )}
                >
                  {translation}
                </span>
                <CatTextPassage size="xs">{translation}</CatTextPassage>
              </CatTooltip>
            </CatSegmentedControlItem>
          ))}
        </CatSegmentedControl>
      </div>
      <div className="d-md-none d-block">
        <MeasureUnitSelectorBody
          activeIndex={activeIndex}
          onChangeUom={onChangeUom}
          uomData={uomData}
        />
      </div>
    </>
  );
};

export default ShortenedMeasureUnitSelectorBody;
